import React from "react";
import {QueryClient, QueryClientProvider} from "react-query";
import SynopticPage from "../Synoptic/SynopticPage";
import Box from "@mui/material/Box";

export default function DashboardOverviewSynopticPage(){
    const queryClient = new QueryClient();

    return(
        <QueryClientProvider client={queryClient}>
            <Box sx={{
                marginTop: 1,
                marginRight: 3
            }}>
                <SynopticPage />
            </Box>
        </QueryClientProvider>
    );
}